document.addEventListener("DOMContentLoaded", function () {
  const hotpoints = document.querySelectorAll(".pin_point");

  hotpoints.forEach((button) => {
    button.addEventListener("click", function () {
      const allChips = document.querySelectorAll(".hotspot-chip__card a");
      allChips.forEach((card) => card.classList.remove("visible"));

      const parentGroup = button.closest(".hotspot-point__group");
      const chipCard = parentGroup.querySelector(".hotspot-chip__card a");

      if (chipCard) {
        chipCard.classList.add("visible");
      }
    });
  });
});
